import React from "react";
import {SentimentVeryDissatisfied} from "@mui/icons-material";
import './NoData.css';

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 09/03/2022
 * @last_update 09/03/2022
 **/
class NoResultFound extends React.Component<{
    children: string
}> {

    render() {

        return (

            <div id="no-result-found-main-container">
                <SentimentVeryDissatisfied id="no-result-found-icon"/>
                <p id="no-result-found-content">{this.props.children}</p>
            </div>

        );

    };

}

export default NoResultFound;
